import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import { OneFormProjectCard } from "../Project/OneFormProjectCard";
import { ProjectActionCreators, AppActionCreators } from "../../../actions";
import { DistrictDropdownOption, ProjectType } from "../../../utils/enums";
import { RouteUrls } from "../../../configs/routeUrls";

class BudgetCardVoteContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let { id } = this.props.match.params;
    if (id) {
      this.props.getProject(id);
    }
    this.props.setBreadcrumbs([
      {
        url: RouteUrls.Budget.list.actual,
        displayName: "Budżet obywatelski",
      },
      {
        url: RouteUrls.Budget.vote.voteFunc(id),
        displayName: "Głosowanie",
      },
    ]);
    this.props.getInitData();
  }

  render() {
    const {
      isAuth,
      uniqueEmailWhileVotingNotLoggedUser,
      emailConfirmationWhileVotingNotLoggedUser,
      isProjectLoading,
      isOnlyOneOffice,
      loggedUserId,
      externalSystemAddress,
      streetFeatures,
      districts,
      loggedDistrictId,
      opinionExecuting,
      voteExecuting,
      loggedUserIsCitizen,
      loggedUserOfficeId,
      isAuthorizeCodeGenerating,
    } = this.props;

    return (
      <OneFormProjectCard
        {...this.props.project}
        consultationTitle="Budżet"
        type={ProjectType.PublicBudget}
        disabled={false}
        isAuth={isAuth}
        isProjectLoading={isProjectLoading}
        isOnlyOneOffice={isOnlyOneOffice}
        loggedUserId={loggedUserId ? loggedUserId : 0}
        loggedUserOfficeId={loggedUserOfficeId}
        loggedDistrictId={
          loggedDistrictId ? loggedDistrictId : DistrictDropdownOption.NotSetted
        }
        loggedUserIsCitizen={loggedUserIsCitizen}
        externalSystemAddress={externalSystemAddress}
        streetFeatures={streetFeatures}
        uniqueEmailWhileVotingNotLoggedUser={
          uniqueEmailWhileVotingNotLoggedUser
        }
        emailConfirmationWhileVotingNotLoggedUser={
          emailConfirmationWhileVotingNotLoggedUser
        }
        districts={districts}
        opinionExecuting={opinionExecuting}
        voteExecuting={voteExecuting}
        isAuthorizeCodeGenerating={isAuthorizeCodeGenerating}
        generateNewAuthorizeCode={this.props.generateNewAuthorizeCode}
        authorizeCodeGenerated={this.props.authorizeCodeGenerated}
        saveAnswers={this.props.updateConsultationForm}
        onCancel={this.props.goBack}
        systemParameters={this.props.systemParameters}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isAuth: state.app.isAuth,
    isProjectLoading: state.project.isProjectLoading,
    isOnlyOneOffice: state.app.offices && state.app.offices.length === 1,
    opinionExecuting: state.project.opinionExecuting,
    voteExecuting: state.project.voteExecuting,
    project: state.project.project,
    loggedUserId: state.app.loggedUser.userId,
    loggedUserOfficeId: state.app.loggedUser.officeId,
    loggedDistrictId:
      state.app.loggedUser.districtId || DistrictDropdownOption.NotSetted,
    loggedUserIsCitizen: state.app.loggedUser.isCitizen || false,
    externalSystemAddress: state.app.officeFooter.eboi || "",
    streetFeatures: state.app.streetFeatures || [],
    districts: state.app.districts || [],
    uniqueEmailWhileVotingNotLoggedUser:
      state.app.systemParameters.uniqueEmailWhileVotingNotLoggedUser || false,
    emailConfirmationWhileVotingNotLoggedUser:
      state.app.systemParameters.emailConfirmationWhileVotingNotLoggedUser ||
      false,
    authorizeCodeGenerated: state.project.authorizeCodeGenerated || false,
    isAuthorizeCodeGenerating: state.project.isAuthorizeCodeGenerating || false,
    systemParameters: state.app.systemParameters,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    ...bindActionCreators(
      { ...ProjectActionCreators, ...AppActionCreators },
      dispatch
    ),
    goBack: () => dispatch(goBack()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BudgetCardVoteContainer);
